export default __webpack_public_path__ + "static/media/loading.1f5e2656.jpg";